export default "__VITE_ASSET__DVHrNsf0__"